import { getEditLocation } from "../../../core/util/functions";
export const bankguaranteeLocation = "/cliring/bankguarantees";
export const getBankGuaranteeEditLocation = (id?: string) =>
  getEditLocation(bankguaranteeLocation, undefined, id);

export const editRouter = getBankGuaranteeEditLocation(":grntId?");
